// extracted by mini-css-extract-plugin
export default {"root":"TL8eoxs_0kx2cupoj8xe"};